import React, { useEffect, useState } from 'react';
import { Link, useLocation, useHistory, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Media,
  Modal
} from 'reactstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// constants
import LocalStrings from '../../languages';
import {
  FILES_URL,
  APP_API_KEY,
  DEVELOPMENT_TYPE,
  INTERVAL_1
} from '../Common/constant';
import { showError, showSuccess } from '../Common/alertmessage';
import appIcons from '../Common/appIcons';
import generateThumb from '../Common/generateThumb';
import { useInterval } from '../Common/util-common';

// actions
import {
  showSidebar,
  loginModal,
  logout,
  commonNetworkModal,
  updateAppuser,
  fetchEventForms,
  fetchUnreadChat
} from '../../actions';
import { fetchUnreadNotificationCount } from '../notifications/actions';
import { setHSPopup } from '../Common/horizontal-sliding-popup/actions';
import {
  clearUserNotifications,
  clearSocialDetails,
  setSelectedNotification,
  fetchUserNotifications
} from '../notifications/actions';

// components
import Loader from '../Common/loader';
import Login from './login';
import Signup from './signup';
import MyProfile from '../myprofile';

// files
import logo from '../../assets/img/fromhtmls/logo.png';
import hamburgerlogo from '../../assets/img/icons/menu.svg';
import login from '../../assets/img/icons/login.svg';
import person from '../../assets/img/icons/person.svg';
import defaultUser from '../../assets/img/placeholders/NoCourse.svg';
import ThreeDotMenuIcon from '../../assets/img/icons/menu-icon.png';
import noimg from '../../assets/img/placeholders/NoImg.svg';

const AdminNavbar = props => {
  const {
    isLoggedIn,
    session,
    modalStatus,
    show,
    signupModalStatus,
    eventDetails,
    userDetails,
    routes,
    deviceSize,
    commonLoaderReducer,
    networkingReducer,
    notificationReducer,
    fetchUnreadMessage,
    fetchNotifications,
    siteControl
  } = props;

  const location = useLocation();
  const history = useHistory();
  const [DDToggle, setDDToggle] = useState(false);

  useEffect(() => {
    // ----- conditional calls
    if (fetchUnreadMessage) {
      props.fetchUnreadChat(session, res => {});
    }
    if (fetchNotifications) {
      props.fetchUnreadNotificationCount(session, res => {});
    }

    // ----- time interval calls
    const interval = setInterval(() => {
      if (fetchUnreadMessage) {
        props.fetchUnreadChat(session, res => {});
      }
      if (fetchNotifications) {
        props.fetchUnreadNotificationCount(session, res => {});
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [fetchUnreadMessage, fetchNotifications]);

  // ----- Timer calculation starts -----
  const calculateTimeLeft = () => {
    let timeLeft = {};

    if (_.isEmpty(eventDetails?.resource?.clients_by_clientidfk))
      return timeLeft;

    let year = new Date().getFullYear();
    const starttime = `${eventDetails?.resource?.clients_by_clientidfk?.validityfrom} 00:00:00`;
    const difference = +new Date(`${starttime}`) - +new Date();

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  Object.keys(timeLeft).forEach(interval => {
    if (!timeLeft[interval]) {
      return;
    }
  });

  useInterval(() => {
    setTimeLeft(calculateTimeLeft());
  }, INTERVAL_1);
  // ----- Timer calculation ends -----

  // ----- Event logo, user image, eventt duration -----
  let eventlogo = logo;
  if (eventDetails?.resource?.eventicon) {
    eventlogo =
      FILES_URL +
      '/' +
      eventDetails?.resource?.eventicon +
      '?api_key=' +
      APP_API_KEY;
  }

  var userImg = userDetails?.profileurl
    ? `${FILES_URL}/${generateThumb({
        url: userDetails?.profileurl
      })}?api_key=${session.apiKey}`
    : '';

  var eventdate = '';
  if (
    eventDetails?.resource?.eventstartdate &&
    eventDetails?.resource?.eventenddate
  ) {
    var startDate = eventDetails.resource.eventstartdate.split('-');
    var endDate = eventDetails.resource.eventenddate.split('-');
    var y1 = startDate[0],
      m1 = startDate[1],
      d1 = startDate[2],
      y2 = endDate[0],
      m2 = endDate[1],
      d2 = endDate[2];

    if (m1 == m2 && y1 == y2 && d1 == d2) {
      var month = moment(eventDetails.resource.eventstartdate).format('MMM');
      var day = moment(eventDetails.resource.eventstartdate).format('Do');
      eventdate = month + ' ' + day + ', ' + y1;
    } else if (m1 == m2 && y1 == y2 && d1 != d2) {
      var month = moment(eventDetails.resource.eventstartdate).format('MMM');
      var day1 = moment(eventDetails.resource.eventstartdate).format('Do');
      var day2 = moment(eventDetails.resource.eventenddate).format('Do');
      eventdate = month + ' ' + day1 + ' - ' + day2 + ', ' + y1;
    } else {
      var month1 = deviceSize.isMobile
        ? moment(eventDetails.resource.eventstartdate).format('MM')
        : moment(eventDetails.resource.eventstartdate).format('MMM');
      var month2 = deviceSize.isMobile
        ? moment(eventDetails.resource.eventenddate).format('MM')
        : moment(eventDetails.resource.eventenddate).format('MMM');
      var day1 = deviceSize.isMobile
        ? moment(eventDetails.resource.eventstartdate).format('DD')
        : moment(eventDetails.resource.eventstartdate).format('Do');
      var day2 = deviceSize.isMobile
        ? moment(eventDetails.resource.eventenddate).format('DD')
        : moment(eventDetails.resource.eventenddate).format('Do');
      if (y1 == y2) {
        if (deviceSize.isMobile) {
          eventdate = `${day1}/${month1} - ${day2}/${month2}, ${y1}`;
        } else {
          eventdate = `${month1} ${day1} - ${month2} ${day2}, ${y1}`;
        }
      } else {
        if (deviceSize.isMobile) {
          eventdate = `${day1}/${month1}/${y1} - ${day2}/${month2}/${y2}`;
        } else {
          eventdate = `${month1} ${day1}, ${y1} - ${month2} ${day2}, ${y2}`;
        }
      }
    }
  }
  // ----- Ends -----

  const openNav = bool => {
    props.showSidebar(bool);
  };

  const _handleLogin = () => {
    props.loginModal({ showModal: true });
  };

  const _handleLogout = () => {
    confirmAlert({
      title: LocalStrings.kLogoutText,
      message: `${LocalStrings.logout_confirm_subtext}?`,
      buttons: [
        {
          label: LocalStrings.button_yes,
          onClick: () => {
            props.logout(session);

            props.history.push({
              pathname: '/overview'
            });
          }
        },
        {
          label: LocalStrings.kNoTextLC,
          onClick: () => {}
        }
      ]
    });
  };

  const handleNetworkStatusUpdate = () => {
    let dataObj = {
      isnetworking: 1,
      appuserid: userDetails.appuserid,
      eventid: userDetails.eventid
    };
    let formRes = JSON.parse(userDetails?.responses);
    _.map(formRes, field => {
      if (field.name == 'isnetworking') {
        field.value = true;
      }
    });
    dataObj.responses = JSON.stringify(formRes);
    props.updateAppuser(session, dataObj, response => {
      if (response.success) {
        props.commonNetworkModal(false);
        showSuccess(LocalStrings.profile_alert_success);
      } else {
        showError(LocalStrings.kSomethingWrong);
      }
    });
  };

  const handleDDSelect = () => {
    setDDToggle(!DDToggle);
    props.setHSPopup({ show: false, component: '', data: {} });
  };

  const handleNotificationClick = () => {
    props.clearSocialDetails();
    props.setSelectedNotification({});

    if (location.pathname == '/notifications') {
      props.clearUserNotifications();
      props.fetchUserNotifications(session, res => {});
    }
  };

  const _renderMenu = () => {
    var routesNew = _.filter(routes, function(list) {
      if (deviceSize.width < 991) {
        return (
          list.display && list.position === 'top' && list.section === 'menu'
        );
      } else {
        return list.display && list.position === 'top';
      }
    }); // custom check is login not display in sidebar

    return routesNew.map((prop, key) => {
      var selected = _.includes(props.location.pathname, prop.path);
      var menuClass = `menu-link mb-1 ${
        selected ? 'selected-menu' : 'unselected-menu'
      }`;

      if (session?.eventid == 1780731138296391 && prop.path === '/agenda')
        return <></>;

      return (
        <DropdownItem
          key={`key_${key}`}
          to={`${prop.path}`}
          className={menuClass}
          tag={Link}
          onClick={handleDDSelect}
        >
          <div className="menu-icons">{prop.icon}</div>{' '}
          <div className="menu-name">{prop.name}</div>
        </DropdownItem>
      );
    });
  };

  var guInitial = `${_.toUpper(LocalStrings.kGuestUser[0])}${_.toUpper(
    LocalStrings.kGuestUser[6]
  )}`;
  var nameInitial = '';
  if (userDetails.firstname && userDetails.lastname) {
    nameInitial = `${_.toUpper(userDetails.firstname[0])}${_.toUpper(
      userDetails.lastname[0]
    )}`;
  }

  return (
    <div className="header-container">
      {/* --------- Navbar section --------- */}
      <div className="row header">
        {/* ------ hamburger icon - Event logo - name - vaid date ------ */}
        <div
          className={`${
            deviceSize.isMobile ? 'col-10' : 'col-9'
          } hamburger-logo-title-section`}
        >
          {/* ------ hamburger logo for mobile screen ------ */}
          {isLoggedIn == true ? (
            <div className="d-block d-sm-block d-md-block d-lg-none hamburger-section">
              <img
                onClick={e => openNav(true)}
                src={hamburgerlogo}
                className="hamburger"
              />
            </div>
          ) : (
            ''
          )}

          {/* ----- event logo ----- */}
          <div className="logo-section">
            <LazyLoadImage
              alt={'Image'}
              effect="blur"
              placeholder={
                <img
                  src={noimg}
                  className="logo"
                  alt="lazy load placeholder on error"
                />
              }
              className="logo"
              src={eventlogo}
              onError={e => {
                e.target.onerror = null;
                e.target.src = noimg;
              }}
            />
          </div>

          {/* ----- Event details - Site open timer ----- */}
          <div className="d-flex" style={{ flexDirection: 'column' }}>
            {/* --- Event name - date section --- */}
            <div className="d-flex">
              {/* --- event title --- */}
              <div className="title-section">
                <div className="title1">
                  {eventDetails.resource.eventname.length >= 30 &&
                  deviceSize.isMobile
                    ? eventDetails.resource.eventname.substring(0, 27) + '...'
                    : eventDetails.resource.eventname}
                </div>
                {DEVELOPMENT_TYPE === 'eventify' ? (
                  <div className="title2">{eventdate}</div>
                ) : (
                  ''
                )}
              </div>
            </div>

            {/* --- Site open timer --- */}
            {isLoggedIn &&
            (siteControl === 'restrict' || siteControl === 'allow-admin') &&
            !_.isEmpty(timeLeft) ? (
              <label>
                <span className="custom-text9-medium-theme">
                  Site opens in{':  '}
                </span>
                <span className="custom-text9-medium-primary">
                  {timeLeft.days > 0 ? (
                    <span>
                      {timeLeft.days}{' '}
                      {_.startCase(_.toLower(LocalStrings.time_day_caps))}
                    </span>
                  ) : timeLeft.hours > 0 ? (
                    <>
                      <span>
                        {timeLeft.hours}{' '}
                        {_.startCase(_.toLower(LocalStrings.time_hour_caps))} :{' '}
                      </span>
                      <span>
                        {timeLeft.minutes}{' '}
                        {_.startCase(_.toLower(LocalStrings.time_minute_caps))}:{' '}
                      </span>
                    </>
                  ) : (
                    <>
                      <span>
                        {timeLeft.minutes}{' '}
                        {_.startCase(_.toLower(LocalStrings.time_minute_caps))}:{' '}
                      </span>
                      <span>
                        {timeLeft.seconds}{' '}
                        {_.startCase(_.toLower(LocalStrings.time_second_caps))}
                      </span>
                    </>
                  )}
                </span>
              </label>
            ) : (
              ''
            )}
          </div>
        </div>

        {/* ------ Attendee profile - Dropdown - Notification - Three dots - Login button ------ */}
        <div
          className={`${
            deviceSize.isMobile ? 'col-2' : 'col-3'
          } profile-notification-dropdown-section`}
        >
          {/* ------- after login - profile img - name - arrow for web view -------- */}
          {isLoggedIn == true ? (
            <>
              <div className="fixed-menu-section d-none d-lg-block ">
                <Navbar
                  className="navbar-top navbar-dark"
                  expand="md"
                  id="navbar-main"
                >
                  <Nav className="align-items-center d-none d-md-flex" navbar>
                    <UncontrolledDropdown nav>
                      <DropdownToggle
                        className="pr-0"
                        nav
                        onClick={() => setDDToggle(!DDToggle)}
                      >
                        <Media className="align-items-center">
                          {/* ------ profile img ------ */}
                          <div className="avatar">
                            {userImg == '' ? (
                              <div className="profile-name-initial-4040">
                                <div className="letter-padding">
                                  {!_.isEmpty(userDetails) ? (
                                    <>
                                      <span>
                                        <span>{nameInitial}</span>
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <span>{guInitial}</span>
                                    </>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <>
                                <LazyLoadImage
                                  alt={'Image'}
                                  effect="blur"
                                  placeholder={
                                    <img
                                      src={noimg}
                                      className="attendee-user-img"
                                      alt="lazy load placeholder on error"
                                    />
                                  }
                                  className="attendee-user-img"
                                  src={userImg}
                                  onError={e => {
                                    e.target.onerror = null;
                                    e.target.src = noimg;
                                  }}
                                />
                              </>
                            )}
                          </div>

                          {/* ---- user name ---- */}
                          <Media className="mx-2 d-md-none d-lg-block avatar-name">
                            <span className="custom-text1-medium">
                              {userDetails?.username}
                            </span>
                          </Media>

                          {/* ----- arrow ---- */}
                          <Media>
                            <span>
                              {DDToggle ? (
                                <i
                                  className="arrow up"
                                  style={{ marginTop: 4 }}
                                ></i>
                              ) : (
                                <i
                                  className="arrow down"
                                  style={{ marginBottom: 1 }}
                                ></i>
                              )}
                            </span>
                          </Media>
                        </Media>
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-arrow" right>
                        {siteControl !== 'restrict' && _renderMenu()}
                        <DropdownItem
                          className="menu-link mb-1 unselected-menu"
                          onClick={_handleLogout}
                        >
                          {/* <div className="" style={{ marginRight: 5 }}>
                            <img src={login} alt="login action" />
                          </div> */}
                          <div className="menu-icons">
                            {appIcons.logoutIcon}
                          </div>{' '}
                          <div className="menu-name">
                            {LocalStrings.kLogoutText}
                          </div>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </Nav>

                  {/* ------- Web view | Notification icon and count - Global search -------- */}
                  {siteControl !== 'restrict' ? (
                    <>
                      <div className="notification-search-section">
                        {/* --- Notification --- */}
                        <a
                          className=""
                          // to={`notifications`}
                          href={`#/notifications`}
                          onClick={handleNotificationClick}
                          style={{ position: 'relative' }}
                        >
                          <div className="notification-icon-right">
                            {appIcons.bellIcon}
                          </div>
                          {notificationReducer?.unread > 0 ? (
                            <>
                              <div
                                className="notification-right-unread-count"
                                style={
                                  notificationReducer?.unread > 99
                                    ? { width: 22 }
                                    : {}
                                }
                              >
                                {notificationReducer?.unread > 99
                                  ? '99+'
                                  : notificationReducer?.unread}
                              </div>
                            </>
                          ) : (
                            ''
                          )}
                        </a>

                        {/* --- Global search */}
                        <a
                          className=""
                          // to={`globalsearch`}
                          href={`#/globalsearch`}
                        >
                          <div
                            className={`${
                              // isLoggedIn ? 'custom-icons' : 'custom-icons-primary'
                              'custom-icons-primary'
                            } notification-icon-right`}
                          >
                            {appIcons.searchIcon}
                          </div>
                        </a>
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </Navbar>
              </div>
            </>
          ) : (
            ''
          )}

          {/* ------ Mobile view | Notification button & count - Global search ------ */}
          {siteControl !== 'restrict' &&
          isLoggedIn &&
          (deviceSize.isMobile || deviceSize.width < 991) ? (
            <>
              <div
                className=""
                style={
                  // { marginRight: 16, zIndex: 1 }
                  { marginRight: 32, zIndex: 1, display: 'flex' }
                }
              >
                {/* --- Notification --- */}
                <a
                  className=""
                  // to={`notifications`}
                  href={`#/notifications`}
                  onClick={handleNotificationClick}
                  style={{ position: 'relative' }}
                >
                  <div
                    className="notification-icon-left"
                    style={{ marginRight: 8 }}
                  >
                    {appIcons.bellIcon}
                  </div>
                  {notificationReducer?.unread > 0 ? (
                    <>
                      <div
                        className="notification-left-unread-count"
                        style={
                          notificationReducer?.unread > 99 ? { width: 22 } : {}
                        }
                      >
                        {notificationReducer?.unread > 99
                          ? '99+'
                          : notificationReducer?.unread}
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </a>

                {/* --- Global search --- */}
                <a
                  className=""
                  // to={`globalsearch`}
                  href={`#/globalsearch`}
                >
                  <div
                    className={`${
                      // isLoggedIn ? 'custom-icons' : 'custom-icons-primary'
                      'custom-icons-primary'
                    } notification-icon-right`}
                  >
                    {appIcons.searchIcon}
                  </div>
                </a>
              </div>
            </>
          ) : (
            ''
          )}

          {/* -------- Mobile view | Login logout three dots -------- */}
          <div
            className={
              isLoggedIn
                ? 'login-logout-section login d-block d-lg-none'
                : 'login-logout-section logout'
            }
          >
            {isLoggedIn ? (
              siteControl !== 'restrict' ? (
                <>
                  <div
                    className=""
                    // expand="md"
                    id={
                      !deviceSize.isMobile
                        ? 'navbar-main'
                        : 'navbar-main-mobile'
                    }
                  >
                    <Nav className="align-items-center d-flex" navbar>
                      <UncontrolledDropdown nav>
                        <DropdownToggle className="pr-0" nav>
                          <Media className="align-items-center">
                            <img
                              src={ThreeDotMenuIcon}
                              className="custom-menu-default-login p-1-"
                            />
                          </Media>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                          {_renderMenu()}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </Nav>
                  </div>
                </>
              ) : (
                ''
              )
            ) : (
              <>
                <button
                  type="button"
                  onClick={_handleLogin}
                  // className="d-none d-sm-block d-md-block d-lg-block d-xl-block custom-button-primary-md login-button-hover"
                  className="custom-button-primary-md login-button-hover"
                >
                  {LocalStrings.kLoginText}
                </button>
                {/* <div
              className="d-sm-none d-md-none d-lg-none d-xl-none custom-icons"
              onClick={_handleLogin}
            >
              <span className="custom-text9-medium-theme mr-1">
                {LocalStrings.kLoginText}
              </span>
              {appIcons.loginIcon}
            </div> */}
                {/* <img
              src={person}
              onClick={_handleLogin}
              className="d-sm-none d-md-none d-lg-none d-xl-none custom-button-default-login login-button-hover p-1"
            /> */}
              </>
            )}
          </div>
        </div>
      </div>

      {/* --------- common modals ---------- */}
      {/* ------ login ------ */}
      {modalStatus && modalStatus.showModal ? (
        <Login history={props.history} />
      ) : (
        ''
      )}
      {/* ------ sign up ------- */}
      {signupModalStatus && signupModalStatus.showModal ? (
        <Signup history={props.history} />
      ) : (
        ''
      )}
      {/* ------ screen blocking common loader ------ */}
      {commonLoaderReducer ? (
        <>
          <Modal
            className=""
            contentClassName="custom-loader-content-class"
            isOpen={commonLoaderReducer}
            size="sm"
            centered
          >
            <Loader />
          </Modal>
        </>
      ) : (
        ''
      )}
      {/* ----- networking popup modal ----- */}
      {networkingReducer ? (
        <>
          <Modal
            className="preview-lesson"
            isOpen={networkingReducer}
            size="md"
            centered
          >
            <div className="modal-header">
              <div className="modal-title custom-text2-medium-primary">
                {LocalStrings.kGDPRConsentTitleText}
              </div>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => props.commonNetworkModal(false)}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="d-flex">
                <div className="col-10 mb-1" style={{ marginLeft: '-10px' }}>
                  <div className="custom-text1-normal">
                    {LocalStrings.kGDPRConsentText}
                  </div>
                </div>
                <div className="col-2">
                  <label className="switch">
                    <input
                      type="checkbox"
                      onChange={handleNetworkStatusUpdate}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
            <div
              className="modal-footer"
              style={{ backgroundColor: '#faeecf' }}
            >
              <div
                className="custom-text1-medium-notes"
                style={{ marginRight: '1.5rem' }}
              >
                <div className="">
                  <span>{LocalStrings.kGDPRNoteText}</span>
                </div>
              </div>
            </div>
          </Modal>
        </>
      ) : (
        ''
      )}
    </div>
  );
};

const mapStateToProps = state => {
  let fetchUnreadMessage = false,
    fetchNotifications = false;
  if (
    state.isLoggedIn &&
    state.session?.userid &&
    state.session.userid > 0 &&
    !state.stopApiCalls
  ) {
    fetchUnreadMessage = true;
    fetchNotifications = true;
  }

  return {
    isLoggedIn: state.isLoggedIn,
    session: state.session,
    modalStatus: state.loginModal,
    signupModalStatus: state.signupModal,
    show: state.showSidebar,
    eventDetails: state.eventDetails,
    userDetails: state.userDetails,
    deviceSize: state.deviceSize,
    commonLoaderReducer: state.commonLoaderReducer,
    networkingReducer: state.networkingReducer,
    notificationReducer: state.notificationUnreadCountReducer,
    siteControl: state.siteControlReducer,
    fetchUnreadMessage,
    fetchNotifications
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showSidebar,
      loginModal,
      logout,
      commonNetworkModal,
      updateAppuser,
      fetchUnreadChat,
      setHSPopup,
      fetchUnreadNotificationCount,
      clearSocialDetails,
      setSelectedNotification,
      fetchEventForms,
      fetchUserNotifications,
      clearUserNotifications
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar);
